// 暂时知识点数据 仅支持区分学段和学科
// studyPeriod:1小学 2初中 3高中
const knowledge_list = [
    // 小学语文
    {
        id: '1',
        label: '汉语拼音基础',
        studyPeriod: 1,
        subjectCode: 1
    },
    {
        id: '2',
        label: '汉字结构',
        studyPeriod: 1,
        subjectCode: 1
    },
    {
        id: '3',
        label: '词语与句子',
        studyPeriod: 1,
        subjectCode: 1
    },
    {
        id: '4',
        label: '阅读与写作',
        studyPeriod: 1,
        subjectCode: 1
    },
    {
        id: '5',
        label: '古诗文积累',
        studyPeriod: 1,
        subjectCode: 1
    },
    // 小学数学
    {
        id: '6',
        label: '数与代数',
        studyPeriod: 1,
        subjectCode: 2
    },
    {
        id: '7',
        label: '图形与几何',
        studyPeriod: 1,
        subjectCode: 2
    },
    {
        id: '8',
        label: '统计与概率',
        studyPeriod: 1,
        subjectCode: 2
    },
    {
        id: '9',
        label: '解决问题',
        studyPeriod: 1,
        subjectCode: 2
    },
    {
        id: '10',
        label: '实践与综合',
        studyPeriod: 1,
        subjectCode: 2
    },
    // 小学英语
    {
        id: '11',
        label: '字母与语音',
        studyPeriod: 1,
        subjectCode: 3
    },
    {
        id: '12',
        label: '词汇与语法',
        studyPeriod: 1,
        subjectCode: 3
    },
    {
        id: '13',
        label: '句子与表达',
        studyPeriod: 1,
        subjectCode: 3
    },
    {
        id: '14',
        label: '日常交际用语',
        studyPeriod: 1,
        subjectCode: 3
    },
    {
        id: '15',
        label: '阅读与写作',
        studyPeriod: 1,
        subjectCode: 3
    },
    // 初中语文
    {
        id: '16',
        label: '基础表达与修辞',
        studyPeriod: 2,
        subjectCode: 1
    },
    {
        id: '17',
        label: '记叙文要素',
        studyPeriod: 2,
        subjectCode: 1
    },
    {
        id: '18',
        label: '小说三要素',
        studyPeriod: 2,
        subjectCode: 1
    },
    {
        id: '19',
        label: '议论文三要素',
        studyPeriod: 2,
        subjectCode: 1
    },
    {
        id: '20',
        label: '‌说明文知识',
        studyPeriod: 2,
        subjectCode: 1
    },
    {
        id: '21',
        label: '句子作用分析',
        studyPeriod: 2,
        subjectCode: 1
    },
    {
        id: '22',
        label: '‌人物描写方法',
        studyPeriod: 2,
        subjectCode: 1
    },
    // 初中数学
    {
        id: '23',
        label: '数与代数',
        studyPeriod: 2,
        subjectCode: 2
    },
    {
        id: '24',
        label: '图形与几何',
        studyPeriod: 2,
        subjectCode: 2
    },
    {
        id: '25',
        label: '‌一次函数',
        studyPeriod: 2,
        subjectCode: 2
    },
    {
        id: '26',
        label: '二次函数',
        studyPeriod: 2,
        subjectCode: 2
    },
    {
        id: '27',
        label: '统计与概率',
        studyPeriod: 2,
        subjectCode: 2
    },
    // 初中英语
    {
        id: '28',
        label: '基础语法',
        studyPeriod: 2,
        subjectCode: 3
    },
    {
        id: '29',
        label: '句型与结构',
        studyPeriod: 2,
        subjectCode: 3
    },
    {
        id: '30',
        label: '动词短语',
        studyPeriod: 2,
        subjectCode: 3
    },
    {
        id: '31',
        label: '介词辨析',
        studyPeriod: 2,
        subjectCode: 3
    },
    {
        id: '32',
        label: '物主代词',
        studyPeriod: 2,
        subjectCode: 3
    },
    {
        id: '33',
        label: '时态应用',
        studyPeriod: 2,
        subjectCode: 3
    },
    // 初中政治
    {
        id: '33',
        label: '成长中的我',
        studyPeriod: 2,
        subjectCode: 7
    },
    {
        id: '34',
        label: '我与他人和集体',
        studyPeriod: 2,
        subjectCode: 7
    },
    {
        id: '35',
        label: '我与国家和社会',
        studyPeriod: 2,
        subjectCode: 7
    },
    // 初中物理
    {
        id: '36',
        label: '力学基础',
        studyPeriod: 2,
        subjectCode: 4
    },
    {
        id: '37',
        label: '光学现象',
        studyPeriod: 2,
        subjectCode: 4
    },
    {
        id: '38',
        label: '电学基础',
        studyPeriod: 2,
        subjectCode: 4
    },
    {
        id: '39',
        label: '热学与能量',
        studyPeriod: 2,
        subjectCode: 4
    },
    {
        id: '40',
        label: '实验与测量',
        studyPeriod: 2,
        subjectCode: 4
    },
    {
        id: '41',
        label: '声学现象',
        studyPeriod: 2,
        subjectCode: 7
    },
    // 初中化学
    {
        id: '42',
        label: '物质的性质',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '43',
        label: '元素与原子',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '44',
        label: '物质分类',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '45',
        label: '元素周期表与化学式',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '46',
        label: '化学反应',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '47',
        label: '实验与操作',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '48',
        label: '化学用语',
        studyPeriod: 2,
        subjectCode: 5
    },
    {
        id: '49',
        label: '重要人物及其成就',
        studyPeriod: 2,
        subjectCode: 5
    },
    // 初中生物
    {
        id: '50',
        label: '生物的基本特征',
        studyPeriod: 2,
        subjectCode: 6
    },
    {
        id: '51',
        label: '生态系统',
        studyPeriod: 2,
        subjectCode: 6
    },
    {
        id: '52',
        label: '生物与环境',
        studyPeriod: 2,
        subjectCode: 6
    },
    {
        id: '53',
        label: '生物体的结构层次',
        studyPeriod: 2,
        subjectCode: 6
    },
    {
        id: '54',
        label: '重要生理过程',
        studyPeriod: 2,
        subjectCode: 6
    },
    // 初中地理
    {
        id: '55',
        label: '地球与地图',
        studyPeriod: 2,
        subjectCode: 9
    },
    {
        id: '56',
        label: '地球运动',
        studyPeriod: 2,
        subjectCode: 9
    },
    {
        id: '57',
        label: '地图应用',
        studyPeriod: 2,
        subjectCode: 9
    },
    {
        id: '58',
        label: '海陆分布',
        studyPeriod: 2,
        subjectCode: 9
    },
    {
        id: '59',
        label: '天气与气候',
        studyPeriod: 2,
        subjectCode: 9
    },
    // 初中历史
    {
        id: '60',
        label: '中国境内早期人类',
        studyPeriod: 2,
        subjectCode: 8
    },
    {
        id: '61',
        label: '原始农耕文明',
        studyPeriod: 2,
        subjectCode: 8
    },
    {
        id: '62',
        label: '早期国家与社会变革',
        studyPeriod: 2,
        subjectCode: 8
    },
    {
        id: '63',
        label: '秦汉统一多民族国家',
        studyPeriod: 2,
        subjectCode: 8
    },
    // 高中语文
    {
        id: '64',
        label: '文体与要素',
        studyPeriod: 3,
        subjectCode: 1
    },
    {
        id: '65',
        label: '表达与修辞',
        studyPeriod: 3,
        subjectCode: 1
    },
    {
        id: '66',
        label: '结构与逻辑',
        studyPeriod: 3,
        subjectCode: 1
    },
    {
        id: '67',
        label: '语法与句式',
        studyPeriod: 3,
        subjectCode: 1
    },
    {
        id: '68',
        label: '文学常识',
        studyPeriod: 3,
        subjectCode: 1
    },
    {
        id: '69',
        label: '标点符号用法',
        studyPeriod: 3,
        subjectCode: 1
    },
    // 高中数学
    {
        id: '70',
        label: '集合与函数',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '71',
        label: '三角函数',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '72',
        label: '数列',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '73',
        label: '立体几何',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '74',
        label: '解析几何',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '75',
        label: '概率统计',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '76',
        label: '导数应用',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '77',
        label: '复数',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '78',
        label: '不等式',
        studyPeriod: 3,
        subjectCode: 2
    },
    {
        id: '79',
        label: '算法初步',
        studyPeriod: 3,
        subjectCode: 2
    },
    // 高中英语
    {
        id: '80',
        label: '高频短语与固定搭配',
        studyPeriod: 3,
        subjectCode: 3
    },
    {
        id: '81',
        label: '重点语法结构',
        studyPeriod: 3,
        subjectCode: 3
    },
    {
        id: '82',
        label: '词汇拓展',
        studyPeriod: 3,
        subjectCode: 3
    },
    {
        id: '83',
        label: '写作高频表达',
        studyPeriod: 3,
        subjectCode: 3
    },
    // 高中物理
    {
        id: '84',
        label: '力学基础',
        studyPeriod: 3,
        subjectCode: 4
    },
    {
        id: '85',
        label: '电磁学核心',
        studyPeriod: 3,
        subjectCode: 4
    },
    {
        id: '86',
        label: '振动与波',
        studyPeriod: 3,
        subjectCode: 4
    },
    {
        id: '87',
        label: '热学与近代物理',
        studyPeriod: 3,
        subjectCode: 4
    },
    {
        id: '88',
        label: '实验重点',
        studyPeriod: 3,
        subjectCode: 4
    },
    // 高中化学
    {
        id: '89',
        label: '化学基本概念',
        studyPeriod: 3,
        subjectCode: 5
    },
    {
        id: '90',
        label: '元素化合物',
        studyPeriod: 3,
        subjectCode: 5
    },
    {
        id: '91',
        label: '化学反应原理',
        studyPeriod: 3,
        subjectCode: 5
    },
    {
        id: '92',
        label: '物质结构',
        studyPeriod: 3,
        subjectCode: 5
    },
    // 高中生物
    {
        id: '93',
        label: '细胞基础',
        studyPeriod: 3,
        subjectCode: 6
    },
    {
        id: '94',
        label: '分子与代谢',
        studyPeriod: 3,
        subjectCode: 6
    },
    {
        id: '95',
        label: '遗传与进化',
        studyPeriod: 3,
        subjectCode: 6
    },
    {
        id: '96',
        label: '生态与环境',
        studyPeriod: 3,
        subjectCode: 6
    },
    // 高中政治
    {
        id: '97',
        label: '社会发展规律',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '98',
        label: '中国特色社会主义',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '99',
        label: '基本经济制度',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '100',
        label: '市场经济体制',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '101',
        label: '人民民主专政',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '102',
        label: '政治制度',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '103',
        label: '依法治国',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '104',
        label: '唯物论',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '105',
        label: '辩证法',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '106',
        label: '认识论',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '107',
        label: '‌国际政治',
        studyPeriod: 3,
        subjectCode: 7
    },
    {
        id: '108',
        label: '法律与生活',
        studyPeriod: 3,
        subjectCode: 7
    },
    // 高中地理
    {
        id: '109',
        label: '地球与地图基础',
        studyPeriod: 3,
        subjectCode: 9
    },
    {
        id: '110',
        label: '自然地理核心',
        studyPeriod: 3,
        subjectCode: 9
    },
    {
        id: '111',
        label: '人文地理重点',
        studyPeriod: 3,
        subjectCode: 9
    },
    {
        id: '112',
        label: '区域可持续发展',
        studyPeriod: 3,
        subjectCode: 9
    },
    {
        id: '113',
        label: '地理信息技术',
        studyPeriod: 3,
        subjectCode: 9
    },
    // 高中历史
    {
        id: '114',
        label: '分封制与宗法制',
        studyPeriod: 3,
        subjectCode: 8
    },
    {
        id: '115',
        label: '‌统一多民族国家形成',
        studyPeriod: 3,
        subjectCode: 8
    },
    {
        id: '116',
        label: '‌近代列强侵略',
        studyPeriod: 3,
        subjectCode: 8
    },
    {
        id: '117',
        label: '‌百家争鸣',
        studyPeriod: 3,
        subjectCode: 8
    },
    {
        id: '118',
        label: '‌制度演变规律',
        studyPeriod: 3,
        subjectCode: 8
    },
    {
        id: '119',
        label: '科技文化成就',
        studyPeriod: 3,
        subjectCode: 8
    },
    {
        id: '120',
        label: '中央集权制度',
        studyPeriod: 3,
        subjectCode: 8
    },
]

export {
    knowledge_list
}